import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '@/app/providers/user';
import { saveReturnTo } from '@/features/auth/services/returnTo';

export function RequireUser({ children }: { children: ReactNode }) {
  const { status } = useCurrentUser();
  const location = useLocation();
  // Don't redirect while the boot-time refresh is still resolving, or we'd bounce
  // an authenticated user to /login on every reload.
  if (status === 'loading') {
    return <p>Loading…</p>;
  }
  if (status === 'unauthenticated') {
    // Remember where they were so we can return here after sign-in.
    saveReturnTo(`${location.pathname}${location.search}`);
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
